<template>
  <section >
    <v-card flat>
      <v-layout row>
          <v-flex xs10  sm10  md6 lg6 xl6 class="header-table">
            <v-flex offset-xs1 offset-sm1 offset-md1 offset-lg1 offset-xl1 >
              <p class="title">Listado de Tipo de Competencias</p>
            </v-flex>
          </v-flex>
          <v-flex xs10  sm10  md6 lg6 xl6  class="header-table">
            <v-flex offset-xs1 offset-sm5 offset-md7 offset-lg8 offset-xl8 >
              <v-btn color="primary"  offset-xs8 offset-sm8 offset-md8 offset-lg8 offset-xl8  @click="go('maintainer')"><v-icon>arrow_back</v-icon>Volver</v-btn>
            </v-flex>
          </v-flex>
        </v-layout>
      <v-card-title>
        <div>
          <v-btn color="primary"  @click.native.stop="dialogAddTipoCompetencia = true" ><v-icon>add</v-icon>Nuevo Tipo Competencia</v-btn>
        </div>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          label="Buscador"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
      </v-card-title>
      <v-data-table
          v-bind:headers="headers"
          v-bind:items="tiposCompetencias"
          v-bind:search="search"
          rows-per-page-text = "Filas por Pagina"
          no-data-text="No hay Tipos de Competencias Creadas"
        >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center">{{ props.item.competence_name }}</td>
          <td class="text-xs-center">{{ props.item.created_at }}</td>
          <td class="text-xs-center">
            <v-btn flat icon color="amber accent-3" @click.native.stop="dialogEditTipoCompetencia = true" @click="currentTipoCompetencia(props.item)" >
              <v-icon>create</v-icon>
            </v-btn>
          </td>
          <td class="text-xs-center">
            <v-btn flat icon color="red darken-2" @click="showDialogDeleteElement(props.item.id)">
              <v-icon>delete</v-icon>
            </v-btn>
            
          </td>
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
          Desde {{ pageStart }} a {{ pageStop }}
        </template>
      </v-data-table>
    </v-card>

<!-- Dialog crear institucion -->
 <v-dialog v-model="dialogAddTipoCompetencia"  max-width="500px" >
  <v-card>
    <v-toolbar flat dark color="primary">
      <v-toolbar-title class="white--text center">Agregar Tipo Competencia</v-toolbar-title>
    </v-toolbar>
    <v-form  >
      <v-card-text>
        <v-container grid-list-sm>
          <v-layout row wrap>
            <v-flex xs12 >
              <v-card>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-flex xs12>
                      <v-text-field
                        name="input-1"
                        label="Descripción"
                        v-model="tipoCompetencia.competence_name"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>  
          </v-layout>
        </v-container>
        <small>*Campos Obligatorios</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn  color="primary" flat @click.native="dialogAddTipoCompetencia = false" >Cancelar</v-btn>
        <v-btn  color="primary" flat @click="submitTipoCompetencia(tipoCompetencia)" >Agregar</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</v-dialog>


<!-- Dialog editar institucion -->
 <v-dialog v-model="dialogEditTipoCompetencia"  max-width="500px" >
  <v-card>
    <v-toolbar flat dark color="primary">
      <v-toolbar-title class="white--text center">Editar Tipo Competencia</v-toolbar-title>
    </v-toolbar>
    <v-form  >
      <v-card-text>
        <v-container grid-list-sm>
          <v-layout row wrap>
            <v-flex xs12 >
              <v-card>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-flex xs12>
                      <v-text-field
                        name="input-1"
                        label="Descripción"
                        v-model="currentTipoCompetencia.competence_name"
                      ></v-text-field>
                    </v-flex>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>  
          </v-layout>
        </v-container>
        <small>*Campos Obligatorios</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn  color="primary" flat @click.native="dialogEditTipoCompetencia = false" >Cancelar</v-btn>
        <v-btn  color="primary" flat @click="editTipoCompetencia(currentTipoCompetencia.id, currentTipoCompetencia)" >Guardar</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</v-dialog>

<v-dialog v-model="dialogDeleteElement"  max-width="500px" >
  <v-card class=" ma-0">
      <v-card-title class="balck--text center headline">¿Estas seguro que lo deseas <span class="white--text">.</span><span class="red--text"> Eliminar</span>?</v-card-title>
    <v-form  >
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn  color="red" outline @click.native="dialogDeleteElement = false" >Cancelar</v-btn>
        <v-btn class="white--text" color="red"  @click="deletTipoCompetencia()" >Eliminar</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</v-dialog>

  <v-snackbar
      :timeout="timeout"
      :color="colorSnackbar"
      v-model="snackbar"
    >
    <v-icon dark>check_circle</v-icon>
      {{ textSnackbar }}
      <v-btn dark flat @click.native="snackbar = false">X</v-btn>
  </v-snackbar>


  </section>
</template>

<script>
import { typeCompetencesService } from '@/services/Competencia/TypeCompetences.service'
export default {
  data () {
    return {
      tiposCompetencias: [],
      tipoCompetencia: {},
      currentTipoCompetencia: {},
      dialogAddTipoCompetencia: false,
      dialogEditTipoCompetencia: false,
      tmp: '',
      search: '',
      pagination: {},
      snackbar: false,
      colorSnackbar: '',
      timeout: 6000,
      textSnackbar: '',
      headers: [
        { text: 'Nombre', align: 'center', value: 'nombre' },
        { text: 'Editar', align: 'center', value: 'editar' },
        { text: 'Eliminar', align: 'center', value: 'eliminar' }
      ],
      elementDelete: 0,
      dialogDeleteElement: false
    }
  },
  methods: {
    loadTiposCompetencias () {
      let vm = this
      typeCompetencesService.query().then(data => {
        vm.tiposCompetencias = data.body
      })
    },
    verLeccion (id) {
      this.$router.push({name: 'showLesson', params: {id: id}})
    },
    submitTipoCompetencia (model) {
      let vm = this
      typeCompetencesService.save(model).then(data => {
        vm.dialogAddTipoCompetencia = false
        vm.mensajeToast('success', true, 'Tipo de Competencia guardada con exito')
        vm.tiposCompetencias = data.body
        vm.tipoCompetencia = {}
      }, response => {
        vm.mensajeToast('error', true, 'Error al guardar tipo de competencia')
      })
    },
    deletTipoCompetencia () {
      let vm = this
      typeCompetencesService.destroy(vm.elementDelete).then(data => {
        vm.dialogDeleteElement = false
        vm.mensajeToast('success', true, 'Tipo de Competencia eliminada con exito')
        vm.tiposCompetencias = data.body
      }, response => {
        vm.mensajeToast('error', true, 'Error al eliminar tipo de competencia')
        vm.dialogDeleteElement = false
      })
    },
    showDialogDeleteElement (id) {
      let vm = this
      vm.elementDelete = id
      vm.dialogDeleteElement = true
    },
    editTipoCompetencia (id, model) {
      let vm = this
      typeCompetencesService.update(id, model).then(data => {
        vm.dialogEditTipoCompetencia = false
        vm.mensajeToast('success', true, 'Tipo de competenica editada con exito')
        vm.tiposCompetencias = data.body
      }, response => {
        vm.mensajeToast('error', true, 'Error al editar tipo de competencia')
        vm.dialogEditTipoCompetencia = false
      })
    },
    setCurrentTipoCompetencia (tipoCompetencia) {
      let vm = this
      vm.currentTipoCompetencia = tipoCompetencia
    },
    mensajeToast (color, snack, texto) {
      let vm = this
      vm.colorSnackbar = color
      vm.snackbar = snack
      vm.textSnackbar = texto
    },
    go (ruta) {
      this.$router.push({name: ruta})
    }
  },
  mounted () {
    let vm = this
    vm.loadTiposCompetencias()
  }
}
</script>

<style scoped>
.header-table{
  min-height: 75px;
  padding-top: 15px;
  background-color: white;
}
</style>




// WEBPACK FOOTER //
// src/components/Administrador/tipoCompetencia.vue